import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TinhTrangTDKTGS } from 'src/app/shared/TinhTrangTDKTGS.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class TinhTrangTDKTGSService extends BaseService{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "TinhTrangTDKTGS";
    }
}

